import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "debug-tool" }
const _hoisted_2 = { class: "search-bar1" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "text-danger mt4 ml4"
}
const _hoisted_6 = {
  key: 1,
  class: "result-area1 mt8"
}
const _hoisted_7 = { class: "nav nav-tabs" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = { class: "custom-control custom-checkbox" }
const _hoisted_12 = { class: "custom-control custom-checkbox ml12 mb4" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "mtx-info-container" }
const _hoisted_15 = { class: "ib mr4" }
const _hoisted_16 = { class: "ib mr4" }
const _hoisted_17 = { class: "ib mr4" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "custom-control custom-checkbox" }
const _hoisted_22 = { class: "custom-control custom-checkbox ml12 mb4" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "movie-info-container" }
const _hoisted_25 = { class: "ib mr4" }
const _hoisted_26 = { class: "ib mr4" }
const _hoisted_27 = { class: "ib mr4" }
const _hoisted_28 = { class: "ib mr4" }
const _hoisted_29 = { class: "ib mr4" }
const _hoisted_30 = { class: "section2" }
const _hoisted_31 = { class: "movie-geo-indices" }
const _hoisted_32 = { class: "ib mr4" }
const _hoisted_33 = { class: "ib mr4" }
const _hoisted_34 = { class: "ib mr4" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }

import { useDebugTool } from './useDebugTool';
import type { DebugToolProps } from 'src/models/top';


export default /*@__PURE__*/_defineComponent({
  __name: 'tool1',
  props: {
    refExtremeMap: {},
    cars: {}
  },
  setup(__props: any) {

const props = __props;

const {
  state,
  dtFormat,
  showMTX,
  removeMTX,
  toggleMTXMapDisp,
  toggleMTXMapTsDisp,
  toggleMovieMapDisp,
  toggleMGIMapDisp,
  setNow,
  saveSearchParams,
  restoreSearchParams,
} = useDebugTool(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "ib ml4",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "ib form-control form-control-sm",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.deviceId) = $event)),
          placeholder: "車載器ID or 車両番号"
        }, null, 512), [
          [_vModelText, _unref(state).search.deviceId]
        ]),
        _createElementVNode("i", {
          class: "ib ml2 far fa-clock",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setNow)('startTs')))
        }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "ib form-control form-control-sm",
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).search.startTs) = $event)),
          placeholder: "期間from"
        }, null, 512), [
          [_vModelText, _unref(state).search.startTs]
        ]),
        _createElementVNode("i", {
          class: "ib ml2 far fa-clock",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(setNow)('endTs')))
        }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "ib form-control form-control-sm",
          required: "",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).search.endTs) = $event)),
          placeholder: "期間to"
        }, null, 512), [
          [_vModelText, _unref(state).search.endTs]
        ]),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary ml8",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(showMTX) && _unref(showMTX)(...args)))
        }, " 検索 ")
      ], 32),
      _createElementVNode("button", {
        class: "btn btn-sm btn-info ml8",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(removeMTX) && _unref(removeMTX)(...args)))
      }, " 地図クリア "),
      _createElementVNode("button", {
        class: "btn btn-sm btn-info ml8",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(saveSearchParams) && _unref(saveSearchParams)(...args))),
        disabled: _unref(state).mtxs.length === 0
      }, " 検索条件保存 ", 8, _hoisted_3),
      _withDirectives(_createElementVNode("select", {
        class: "ib form-control form-control-sm ml8",
        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(restoreSearchParams) && _unref(restoreSearchParams)(...args))),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).searchParamsToRestore) = $event))
      }, [
        _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "- 検索条件リストア -", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).searchParamCandidacies, (e, idx) => {
          return (_openBlock(), _createElementBlock("option", {
            key: idx,
            value: e
          }, _toDisplayString(idx + 1) + ". 車載器ID: " + _toDisplayString(e.deviceId) + " 期間: " + _toDisplayString(e.startTs) + " 〜 " + _toDisplayString(e.endTs), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, _unref(state).searchParamsToRestore]
      ])
    ]),
    (_unref(state).errorMsg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(state).errorMsg), 1))
      : _createCommentVNode("", true),
    (_unref(state).mtxs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _unref(state).activeTab === 'mtxs'}]),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(state).activeTab = 'mtxs'))
              }, [...(_cache[22] || (_cache[22] = [
                _createElementVNode("span", { class: "ib mtx-prefix" }, null, -1),
                _createTextVNode("MTX情報 ", -1)
              ]))], 2)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _unref(state).activeTab === 'movies'}]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(state).activeTab = 'movies'))
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("div", { class: "ib movie-prefix" }, [
                  _createElementVNode("span", { class: "icon-movie-file" }),
                  _createElementVNode("span", { class: "icon-movie-camera" })
                ], -1),
                _createTextVNode("動画情報 ", -1)
              ]))], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane", {active: _unref(state).activeTab === 'mtxs'}])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).disp.mtxs) = $event)),
                  onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(toggleMTXMapDisp) && _unref(toggleMTXMapDisp)(...args))),
                  id: "dbg-top-tool1-disp-mtxs"
                }, null, 544), [
                  [_vModelCheckbox, _unref(state).disp.mtxs]
                ]),
                _cache[24] || (_cache[24] = _createElementVNode("label", {
                  class: "custom-control-label",
                  for: "dbg-top-tool1-disp-mtxs"
                }, " MTX地図表示 ", -1))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(state).disp.mtxTimestamps) = $event)),
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(toggleMTXMapTsDisp) && _unref(toggleMTXMapTsDisp)(...args))),
                  id: "dbg-top-tool1-disp-mtx-tss",
                  disabled: !_unref(state).disp.mtxs
                }, null, 40, _hoisted_13), [
                  [_vModelCheckbox, _unref(state).disp.mtxTimestamps]
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("label", {
                  class: "custom-control-label",
                  for: "dbg-top-tool1-disp-mtx-tss"
                }, " 時刻表示 ", -1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, "車載器ID: " + _toDisplayString(_unref(state).search.searchedDeviceId), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).mtxs, (mtx) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: _normalizeClass(["mtx-info", {
              'under-calc': !mtx.isPlaceFilled,
              'no-kp': mtx.isPlaceFilled && !mtx.kilopost,
              'yes-kp': mtx.isPlaceFilled && mtx.kilopost,
            }]),
                    key: mtx.id
                  }, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "ib circle" }, null, -1)),
                    _createElementVNode("span", _hoisted_15, "時刻:" + _toDisplayString(_unref(dtFormat)(mtx.ts)), 1),
                    _createElementVNode("span", _hoisted_16, "緯度:" + _toDisplayString(mtx.location.lat), 1),
                    _createElementVNode("span", _hoisted_17, "経度:" + _toDisplayString(mtx.location.lon), 1),
                    (mtx.isPlaceFilled)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!!mtx.kilopost)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, " KP:" + _toDisplayString(mtx.kilopost.roadName) + " " + _toDisplayString(mtx.kilopost.direction) + " " + _toDisplayString(mtx.kilopost.placeName) + " " + _toDisplayString(mtx.kilopost.kp), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, " KP:なし "))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, " KP:計算中 "))
                  ], 2))
                }), 128))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane", {active: _unref(state).activeTab === 'movies'}])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(state).disp.movies) = $event)),
                  onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_unref(toggleMovieMapDisp) && _unref(toggleMovieMapDisp)(...args))),
                  id: "dbg-top-tool1-disp-movies"
                }, null, 544), [
                  [_vModelCheckbox, _unref(state).disp.movies]
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("label", {
                  class: "custom-control-label",
                  for: "dbg-top-tool1-disp-movies"
                }, " 動画情報地図表示 ", -1))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(state).disp.movieGeoIndices) = $event)),
                  onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(toggleMGIMapDisp) && _unref(toggleMGIMapDisp)(...args))),
                  id: "dbg-top-tool1-disp-mgis",
                  disabled: !_unref(state).disp.movies
                }, null, 40, _hoisted_23), [
                  [_vModelCheckbox, _unref(state).disp.movieGeoIndices]
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("label", {
                  class: "custom-control-label",
                  for: "dbg-top-tool1-disp-mgis"
                }, " 動画再生可能箇所地図表示 ", -1))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, "車載器ID: " + _toDisplayString(_unref(state).search.searchedDeviceId), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).movies, (movie) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "movie-info",
                    key: movie.id
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_25, "動画ID:" + _toDisplayString(movie.id), 1),
                      _createElementVNode("span", _hoisted_26, "開始時刻:" + _toDisplayString(_unref(dtFormat)(movie.startTs)), 1),
                      _createElementVNode("span", _hoisted_27, "緯度:" + _toDisplayString(movie.location.lat), 1),
                      _createElementVNode("span", _hoisted_28, "経度:" + _toDisplayString(movie.location.lon), 1),
                      _createElementVNode("span", _hoisted_29, "動画尺:" + _toDisplayString(movie.duration) + "秒", 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("ul", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movie.movieGeoIndices, (gi) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: gi.id
                          }, [
                            _createElementVNode("span", _hoisted_32, "経過秒数:" + _toDisplayString(gi.tsMsecDiff / 1000) + "秒", 1),
                            _createElementVNode("span", _hoisted_33, "緯度:" + _toDisplayString(gi.location.lat), 1),
                            _createElementVNode("span", _hoisted_34, "経度:" + _toDisplayString(gi.location.lon), 1),
                            (gi.isPlaceFilled)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (!!gi.kilopost)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " KP:" + _toDisplayString(gi.kilopost.roadName) + " " + _toDisplayString(gi.kilopost.direction) + " " + _toDisplayString(gi.kilopost.placeName) + " " + _toDisplayString(gi.kilopost.kp), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_36, " KP:なし "))
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_37, " KP:計算中 "))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})